import React from 'react'
import MicroFrontend from "../MicroFrontend"
import MicroFrontendContainer from './MicroFrontendContainer';

const MagnittFooter = ({ history }) => {
    return (
        <MicroFrontendContainer
            MicroFrontend={MicroFrontend}
            history={history}
            name="MagnittFooter"
            height="238.15px"
            skeletonId="magnittFooterSkeleton"
            removeAbsolutePosition={true}
            className='magnitt-footer-container'
        />
    )
}

export default (MagnittFooter);
